import { DeprecatedApiService, OrganizationResource, ScimTokenResource } from '@mode/legacy/data-access-model-js';
import { OrgSettingsService } from '@mode/workspace-settings/shell-angularjs';

export class IdentityScimService {
  static $inject = ['ApiService', 'OrgSettingsService'];

  constructor(
    private apiService: DeprecatedApiService,
    private orgSettingsService: OrgSettingsService
  ) {}

  public scimIsEnabled(scimToken: ScimTokenResource): boolean {
    return !!(scimToken && scimToken.enabled_at);
  }

  public createScimToken(organization: OrganizationResource): angular.IPromise<ScimTokenResource> {
    return this.apiService.create(organization, 'new_scim_token', {});
  }

  public getScimToken(organization: OrganizationResource): angular.IPromise<ScimTokenResource> {
    return this.orgSettingsService.getScimToken(organization);
  }

  public disableScimToken(scimToken: ScimTokenResource): angular.IPromise<ScimTokenResource> {
    return this.apiService.edit<ScimTokenResource>(scimToken, {
      enabled: false,
    });
  }

  public enableScim(
    organization: OrganizationResource,
    scimToken?: ScimTokenResource
  ): angular.IPromise<ScimTokenResource> {
    if (scimToken) {
      return this.apiService.edit<ScimTokenResource>(scimToken, {
        enabled: true,
      });
    } else {
      return this.createScimToken(organization);
    }
  }

  public toggleProvisioning(scimToken: ScimTokenResource): angular.IPromise<ScimTokenResource> {
    const newUserProvisionValue = !scimToken.only_scim_provision;
    return this.apiService.edit<ScimTokenResource>(scimToken, {
      only_scim_provision: newUserProvisionValue,
    });
  }
}
